import * as find from './reducers/find';
import * as create from './reducers/create';
import * as open from './reducers/open';
import * as close from './reducers/close';
import * as update from './reducers/update';
import * as getTransactions from './reducers/get-transactions';
import * as topUp from './reducers/top-up';
import * as withdraw from './reducers/withdraw';
import * as adjust from './reducers/adjust';
import * as setLimit from './reducers/set-limit';
import * as setWageringLimit from './reducers/set-wagering-limit';
import * as selfExclusion from './reducers/self-exclusion';
import * as playBreak from './reducers/play-break';
import * as realityCheck from './reducers/reality-check';
import * as updateData from './reducers/update-data';
import * as getAssetFlows from './reducers/get-asset-flows';
import * as removePaymentMethod from './reducers/remove-payment-method';
import * as getCounters from './reducers/get-counters';
import * as saveHistory from './reducers/save-history';
import * as referalValidation from './reducers/referal-validation';
import * as currencyValidation from './reducers/currency-validation';
import * as freebet from './reducers/get-freebet-credits';
import * as freebetRemove from './reducers/remove-freebet-credit';
import * as addFreebet from './reducers/add-freebet-credit';
import * as freebetHistory from './reducers/get-freebet-history';
import * as requestReactivation from './reducers/request-reactivation';
import * as reactivate from './reducers/reactivate';

import { simple } from 'src/utils/reducers';

// eslint-disable-next-line import/no-default-export
export default simple({
    CUSTOMERS_FIND_REQUEST: find.request,
    CUSTOMERS_FIND_FINISH: find.finish,
    CUSTOMERS_FIND_ERROR: find.error,
    CUSTOMERS_FIND_CLEAR: find.clear,

    CUSTOMERS_CREATE_REQUEST: create.request,
    CUSTOMERS_CREATE_FINISH: create.finish,
    CUSTOMERS_CREATE_ERROR: create.error,
    CUSTOMERS_CREATE_CLEAR: create.clear,

    CUSTOMERS_CLOSE_REQUEST: close.request,
    CUSTOMERS_OPEN_REQUEST: open.request,
    CUSTOMERS_OPEN_FINISH: open.finish,
    CUSTOMERS_OPEN_ERROR: open.error,
    CUSTOMERS_OPEN_CLEAR: open.clear,

    CUSTOMERS_UPDATE_REQUEST: update.request,
    CUSTOMERS_UPDATE_FINISH: update.finish,
    CUSTOMERS_UPDATE_ERROR: update.error,
    CUSTOMERS_UPDATE_CLEAR: update.clear,

    CUSTOMERS_GET_TRANSACTIONS_REQUEST: getTransactions.request,
    CUSTOMERS_GET_TRANSACTIONS_FINISH: getTransactions.finish,
    CUSTOMERS_GET_TRANSACTIONS_ERROR: getTransactions.error,
    CUSTOMERS_GET_TRANSACTIONS_CLEAR: getTransactions.clear,

    CUSTOMERS_GET_COUNTERS_REQUEST: getCounters.request,
    CUSTOMERS_GET_COUNTERS_FINISH: getCounters.finish,
    CUSTOMERS_GET_COUNTERS_ERROR: getCounters.error,
    CUSTOMERS_GET_COUNTERS_CLEAR: getCounters.clear,

    CUSTOMERS_GET_FREEBET_CREDITS_REQUEST: freebet.request,
    CUSTOMERS_GET_FREEBET_CREDITS_FINISH: freebet.finish,
    CUSTOMERS_GET_FREEBET_CREDITS_ERROR: freebet.error,

    CUSTOMERS_REMOVE_FREEBET_CREDITS_REQUEST: freebetRemove.request,
    CUSTOMERS_REMOVE_FREEBET_CREDITS_FINISH: freebetRemove.finish,
    CUSTOMERS_REMOVE_FREEBET_CREDITS_ERROR: freebetRemove.error,

    CUSTOMERS_ADD_FREEBET_CREDITS_REQUEST: addFreebet.request,
    CUSTOMERS_ADD_FREEBET_CREDITS_FINISH: addFreebet.finish,
    CUSTOMERS_ADD_FREEBET_CREDITS_ERROR: addFreebet.error,

    CUSTOMERS_GET_FREEBET_HISTORY_REQUEST: freebetHistory.request,
    CUSTOMERS_GET_FREEBET_HISTORY_FINISH: freebetHistory.finish,
    CUSTOMERS_GET_FREEBET_HISTORY_ERROR: freebetHistory.error,

    CUSTOMERS_TOP_UP_REQUEST: topUp.request,
    CUSTOMERS_TOP_UP_FINISH: topUp.finish,
    CUSTOMERS_TOP_UP_FORM: topUp.form,
    CUSTOMERS_TOP_UP_ERROR: topUp.error,
    CUSTOMERS_TOP_UP_CLEAR: topUp.clear,

    CUSTOMERS_WITHDRAW_REQUEST: withdraw.request,
    CUSTOMERS_WITHDRAW_FINISH: withdraw.finish,
    CUSTOMERS_WITHDRAW_FORM: withdraw.form,
    CUSTOMERS_WITHDRAW_ERROR: withdraw.error,
    CUSTOMERS_WITHDRAW_CLEAR: withdraw.clear,

    CUSTOMERS_ADJUST_REQUEST: adjust.request,
    CUSTOMERS_ADJUST_FINISH: adjust.finish,
    CUSTOMERS_ADJUST_ERROR: adjust.error,
    CUSTOMERS_ADJUST_CLEAR: adjust.clear,

    CUSTOMERS_SET_LIMIT_REQUEST: setLimit.request,
    CUSTOMERS_SET_LIMIT_FINISH: setLimit.finish,
    CUSTOMERS_SET_LIMIT_ERROR: setLimit.error,
    CUSTOMERS_SET_LIMIT_CLEAR: setLimit.clear,

    CUSTOMERS_SET_WAGERING_LIMIT: setWageringLimit.request,
    CUSTOMERS_SET_WAGERING_LIMIT_ERROR: setWageringLimit.error,
    CUSTOMERS_SET_WAGERING_LIMIT_FINISH: setWageringLimit.finish,

    CUSTOMERS_SELF_EXCLUSION_REQUEST: selfExclusion.request,
    CUSTOMERS_SELF_EXCLUSION_FINISH: selfExclusion.finish,
    CUSTOMERS_SELF_EXCLUSION_ERROR: selfExclusion.error,
    CUSTOMERS_SELF_EXCLUSION_CLEAR: selfExclusion.clear,

    CUSTOMERS_PLAY_BREAK_REQUEST: playBreak.request,
    CUSTOMERS_PLAY_BREAK_FINISH: playBreak.finish,
    CUSTOMERS_PLAY_BREAK_ERROR: playBreak.error,
    CUSTOMERS_PLAY_BREAK_CLEAR: playBreak.clear,

    CUSTOMERS_REALITY_CHECK_REQUEST: realityCheck.request,
    CUSTOMERS_REALITY_CHECK_FINISH: realityCheck.finish,
    CUSTOMERS_REALITY_CHECK_ERROR: realityCheck.error,
    CUSTOMERS_REALITY_CHECK_CLEAR: realityCheck.clear,

    CUSTOMERS_GET_ASSET_FLOWS_REQUEST: getAssetFlows.request,
    CUSTOMERS_GET_ASSET_FLOWS_FINISH: getAssetFlows.finish,
    CUSTOMERS_GET_ASSET_FLOWS_ERROR: getAssetFlows.error,
    CUSTOMERS_GET_ASSET_FLOWS_CLEAR: getAssetFlows.clear,

    CUSTOMERS_REMOVE_PAYMENT_METHOD_ERROR: removePaymentMethod.error,

    CUSTOMERS_UPDATE_DATA_BULK: updateData.bulk,

    CUSTOMERS_SAVE_HISTORY_REQUEST: saveHistory.request,

    CUSTOMERS_CURRENCY_VALIDATION_REQUEST: currencyValidation.request,
    CUSTOMERS_CURRENCY_VALIDATION_FINISH: currencyValidation.finish,
    CUSTOMERS_CURRENCY_VALIDATION_ERROR: currencyValidation.error,

    CUSTOMERS_REFERAL_VALIDATION_REQUEST: referalValidation.request,
    CUSTOMERS_REFERAL_VALIDATION_FINISH: referalValidation.finish,
    CUSTOMERS_REFERAL_VALIDATION_ERROR: referalValidation.error,

    CUSTOMER_REQUEST_REACTIVATION_REQUEST: requestReactivation.request,
    CUSTOMER_REQUEST_REACTIVATION_FINISH: requestReactivation.finish,
    //CUSTOMER_REQUEST_REACTIVATION_ERROR: requestReactivation.error,

    CUSTOMER_REACTIVATE_REQUEST: reactivate.request,
    CUSTOMER_REACTIVATE_FINISH: reactivate.finish,
    //CUSTOMER_REACTIVATE_ERROR: reactivate.error
});
